import React from 'react';
import { Receipt as ReceiptIcon, ChevronRight, Mail, MessageSquare } from 'lucide-react';

const Receipt = ({ onYes, onNo, onContinue, onEmail, onSms, amount, config }) => {
  // Generate QR code URL for https://www.tnsi.com
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=80x80&data=${encodeURIComponent('https://www.tnsi.com')}`;

  return (
    <div className={`bg-white text-gray-800 h-full flex flex-col p-3 ${config.ui.maxWidth} mx-auto`}>
      {/* Header */}
      <div className="text-center mb-4">
        <ReceiptIcon className="w-8 h-8 text-blue-600 mx-auto mb-2" />
        <div className="text-lg font-bold text-gray-800">Transaction Receipt</div>
      </div>

      {/* Digital Receipt Section */}
      <div className="flex-1 flex justify-center mb-4">
        {/* Digital Receipt Section */}
        <div className="w-64">
          <div className="bg-white border border-gray-300 p-3 rounded text-xs font-mono h-full flex flex-col">
            <div className="text-center font-bold mb-2">RECEIPT</div>
            <div className="text-center mb-2">{'='.repeat(20)}</div>
            <div className="space-y-1 flex-1">
              <div>DATE: {new Date().toLocaleDateString()}</div>
              <div>TIME: {new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</div>
              <div>CARD: ****1234</div>
              <div>TYPE: SALE</div>
              <div>AMOUNT: ${amount || '0.00'}</div>
              <div>APPROVAL: 123456</div>
              <div>REF: {Math.random().toString(36).substr(2, 6).toUpperCase()}</div>
            </div>
            <div className="text-center mt-2">{'='.repeat(20)}</div>
            <div className="text-center text-xs mt-1">THANK YOU</div>
            <div className="flex flex-col items-center mt-2">
              <img 
                src={qrCodeUrl} 
                alt="QR Code - tnsi.com" 
                className="w-12 h-12"
              />
              <div className="text-xs text-gray-500 text-center mt-1">Scan QR for receipt</div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Action Buttons */}
      <div className="text-sm text-gray-600 text-center mb-3">Choose an option:</div>
      <div className="grid grid-cols-2 gap-3 w-full">
        <button 
          onClick={onYes}
          className="py-3 px-4 bg-blue-600 text-white font-bold text-sm rounded-lg hover:bg-blue-700 transition-colors"
        >
          Print Receipt
        </button>
        <button 
          onClick={onEmail}
          className="py-3 px-4 bg-blue-600 text-white font-bold text-sm rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
        >
          <Mail className="w-4 h-4" />
          Email
        </button>
        <button 
          onClick={onSms}
          className="py-3 px-4 bg-blue-600 text-white font-bold text-sm rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
        >
          <MessageSquare className="w-4 h-4" />
          SMS
        </button>
        <button 
          onClick={onContinue || onNo}
          className="py-3 px-4 bg-blue-600 text-white font-bold text-sm rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
        >
          Continue
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default Receipt;